/* Rad Power Bike bottle holder: native Color selectors, prices and cart callbacks remain authoritative. */
(() => {
  'use strict';
  if (window.GzBikeColorsInstalled) return;
  window.GzBikeColorsInstalled = true;
  // Capture a URL fallback early; server-rendered request metadata below takes priority.
  const linkedVariantId = new URL(window.location.href).searchParams.get('variant');
  const productId = '4801549434960';
  const rootSelector = '.gz-patch-purchase [data-gz-bike-colors]';
  const instances = new Map();
  const setClass = (element, name, enabled) => {
    if (element.classList.contains(name) !== enabled) element.classList.toggle(name, enabled);
  };
  const setDisabled = (element, disabled) => {
    if (element.disabled !== disabled) element.disabled = disabled;
  };
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  // Fail closed even before native selectors exist. Valid clicks pass to native AJAX untouched.
  function purchaseGuard(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || (event.type === 'click' && !target.closest('.add_to_cart, .shopify-payment-button'))) return;
    const root = target.closest(rootSelector);
    if (!root || root.dataset.productId !== productId) return;
    const instance = instances.get(root);
    if (!instance || !instance.purchaseAllowed()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (instance) instance.focusMissing();
    }
  }
  document.addEventListener('click', purchaseGuard, true);
  document.addEventListener('submit', purchaseGuard, true);

  function mount(root) {
    if (instances.has(root) || root.dataset.productId !== productId) return;
    let product;
    let inventoryRows;
    try {
      product = JSON.parse(root.dataset.product);
      inventoryRows = JSON.parse(root.dataset.variantInventory);
    } catch (_) { return; }
    const names = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    if (String(product.id) !== productId || names.length !== 1 || String(names[0]).trim().toLowerCase() !== 'color' || !Array.isArray(product.variants) || product.variants.length !== 3 || !Array.isArray(inventoryRows) || root.dataset.product_form_style !== 'select') return;
    const initialLinkedVariantId = root.hasAttribute('data-gz-linked-variant') ? root.dataset.gzLinkedVariant : linkedVariantId;
    const inventory = new Map(inventoryRows.map(row => [String(row.id), row]));
    if (product.variants.some(variant => !inventory.has(String(variant.id)))) return;
    const form = root.querySelector('form');
    const master = form && form.querySelector('select[name="id"][data-variants]');
    const input = form && form.querySelector('input[name="quantity"][type="number"]');
    const atc = form && form.querySelector('.add_to_cart');
    const details = root.closest('.gz-patch-purchase');
    if (!form || !master || !input || !atc || !details) return;
    const jq = window.jQuery;
    const currency = window.Shopify?.currency?.active || root.dataset.shopCurrency || 'USD';
    let money;
    try { money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}); }
    catch (_) { return; }
    const format = cents => money.format(Number(cents) / 100);
    const busy = () => Boolean(atc.querySelector('.zoomOut'));
    const paymentInert = new Map();
    let colorSelect = null;
    let group = null;
    let startingPrice = null;
    let nativePrice = null;
    let ready = false;
    let queued = false;
    let destroyed = false;
    let oldHidden = false;
    let originalSelectDisabled;
    let lastVariantKey;
    let stepTimer = null;

    function stockCap(variant) {
      const row = variant && inventory.get(String(variant.id));
      if (!row) return 0;
      if (!row.inventory_management || row.inventory_policy !== 'deny') return Infinity;
      const value = Number(row.inventory_quantity);
      return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
    }
    function selection() {
      const value = ready && colorSelect ? colorSelect.value : '';
      const variant = value ? product.variants.find(item => String(item.options[0]) === value) : null;
      const option = colorSelect && colorSelect.options[colorSelect.selectedIndex];
      const enabled = Boolean(option && !option.disabled && !option.hidden && !(option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled));
      return {
        variant,
        complete: Boolean(variant),
        allowed: Boolean(ready && variant && variant.available && stockCap(variant) > 0 && enabled && !colorSelect.disabled && !master.disabled && String(variant.id) === String(master.value))
      };
    }
    function maximum() {
      const state = selection();
      if (state.variant) return stockCap(state.variant);
      const caps = product.variants.filter(variant => variant.available).map(stockCap);
      return caps.length ? Math.max(...caps) : 0;
    }
    function normalize() {
      const max = maximum();
      if (max < 1) return false;
      let value = Math.floor(Number(input.value));
      if (!Number.isSafeInteger(value)) value = 1;
      const normalized = String(Math.min(max, Math.max(1, value)));
      if (input.value !== normalized) input.value = normalized;
      return true;
    }
    function applyMaximum() {
      const max = maximum();
      if (Number.isFinite(max)) {
        if (input.getAttribute('max') !== String(max)) input.setAttribute('max', String(max));
      } else if (input.hasAttribute('max')) input.removeAttribute('max');
    }
    function schedule() {
      if (queued || destroyed) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        if (!destroyed && root.isConnected) reconcile();
      });
    }
    function renderColors() {
      if (!group || !colorSelect) return;
      const rows = Array.from(group.children);
      rows.forEach(row => {
        const option = Array.from(colorSelect.options).find(item => item.value === row.dataset.colorValue);
        const variant = product.variants.find(item => String(item.options[0]) === row.dataset.colorValue);
        const disabledGroup = option && option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled;
        setDisabled(row, Boolean(!option || option.disabled || disabledGroup || colorSelect.disabled || !variant?.available || stockCap(variant) < 1 || busy()));
        const hidden = Boolean(option?.hidden);
        if (row.hidden !== hidden) row.hidden = hidden;
        const label = row.querySelector('.gz-bike-color-name');
        setText(label, row.dataset.colorValue.toUpperCase() + (!variant?.available || stockCap(variant) < 1 ? ' — SOLD OUT' : ''));
        const checked = colorSelect.value === row.dataset.colorValue;
        if (row.getAttribute('aria-checked') !== String(checked)) row.setAttribute('aria-checked', String(checked));
      });
      const active = rows.find(row => !row.disabled && !row.hidden && row.dataset.colorValue === colorSelect.value) || rows.find(row => !row.disabled && !row.hidden);
      rows.forEach(row => { if (row.tabIndex !== (row === active ? 0 : -1)) row.tabIndex = row === active ? 0 : -1; });
    }
    function reconcile() {
      if (!ready) return initialize();
      const pending = busy();
      if (pending && originalSelectDisabled === undefined) {
        originalSelectDisabled = colorSelect.disabled;
        setDisabled(colorSelect, true);
      } else if (!pending && originalSelectDisabled !== undefined) {
        setDisabled(colorSelect, originalSelectDisabled);
        originalSelectDisabled = undefined;
      }
      const state = selection();
      applyMaximum();
      const key = state.variant ? String(state.variant.id) : '';
      if (lastVariantKey !== key) {
        lastVariantKey = key;
        normalize();
      }
      setClass(details, 'gz-bike-price-incomplete', Boolean(startingPrice && !state.complete));
      setClass(root, 'product-form--option-selected', state.complete);
      setClass(root, 'product-form--is-valid', state.complete);
      const allUnavailable = product.variants.every(variant => !variant.available || stockCap(variant) < 1);
      setClass(atc, 'make-selection', !state.complete && !allUnavailable);
      // Do not enable ATC. Native variant and AJAX callbacks own that transition.
      if (!state.allowed || pending) {
        setDisabled(atc, true);
        setClass(atc, 'disabled', true);
      }
      if (!state.complete && !pending) setText(atc.querySelector('.text'), allUnavailable ? (window.PXUTheme?.translation?.sold_out_text || 'Sold out') : (atc.dataset.label_make_selection || 'Make a selection'));
      root.querySelectorAll('.shopify-payment-button').forEach(payment => {
        if (!paymentInert.has(payment)) paymentInert.set(payment, payment.inert);
        const inert = !state.allowed || pending || paymentInert.get(payment);
        if (payment.inert !== inert) payment.inert = inert;
      });
      renderColors();
    }
    function chooseColor(value) {
      if (!ready || busy() || colorSelect.disabled) return;
      const option = Array.from(colorSelect.options).find(item => item.value === value);
      const variant = product.variants.find(item => String(item.options[0]) === value);
      if (!option || option.disabled || option.hidden || (option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled) || !variant?.available || stockCap(variant) < 1) return;
      if (colorSelect.value !== value || String(master.value) !== String(variant.id)) {
        colorSelect.value = value;
        colorSelect.dispatchEvent(new Event('change', {bubbles: true}));
      }
      schedule();
    }
    function changed(event) {
      if (event.type === 'change') normalize();
      schedule();
    }
    function purchaseAllowed() {
      if (!ready) return false;
      const valid = normalize() && selection().allowed && !busy() && !input.disabled && !atc.disabled && !atc.classList.contains('disabled');
      schedule();
      return valid;
    }
    function focusMissing() {
      if (!busy() && !selection().complete) group?.querySelector('button:not(:disabled)')?.focus();
    }
    function initialize() {
      if (ready || destroyed) return;
      const selectors = Array.from(root.querySelectorAll('select.single-option-selector'));
      if (selectors.length !== 1 || !selectors[0].options.length) return;
      const select = selectors[0];
      const values = product.variants.map(variant => String(variant.options[0]));
      if (new Set(values).size !== 3 || values.some(value => !Array.from(select.options).some(option => option.value === value))) return;
      const chips = {Black: '#222222', Orange: '#f27924', White: '#ffffff'};
      if (values.some(value => !Object.prototype.hasOwnProperty.call(chips, value))) return;
      colorSelect = select;
      group = document.createElement('div');
      group.className = 'gz-bike-color-options';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', 'Color');
      values.forEach(value => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'gz-bike-color-option';
        row.dataset.colorValue = value;
        row.setAttribute('role', 'radio');
        row.setAttribute('aria-checked', 'false');
        const chip = document.createElement('span');
        chip.className = 'gz-bike-color-chip';
        chip.style.backgroundColor = chips[value];
        chip.setAttribute('aria-hidden', 'true');
        const label = document.createElement('span');
        label.className = 'gz-bike-color-name';
        label.textContent = value.toUpperCase();
        row.append(chip, label);
        group.appendChild(row);
      });
      group.addEventListener('click', event => {
        const row = event.target instanceof Element ? event.target.closest('.gz-bike-color-option') : null;
        if (row && group.contains(row)) chooseColor(row.dataset.colorValue);
      });
      group.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        const rows = Array.from(group.children).filter(row => !row.disabled && !row.hidden);
        const index = rows.indexOf(event.target.closest('.gz-bike-color-option'));
        if (!rows.length || index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? rows.length - 1 : (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + rows.length) % rows.length;
        chooseColor(rows[next].dataset.colorValue);
        rows[next].focus();
      });
      const prices = product.variants.filter(variant => variant.available && stockCap(variant) > 0).map(variant => Number(variant.price)).filter(Number.isFinite);
      nativePrice = details.querySelector('.modal_price [data-price-ui]');
      if (nativePrice && prices.length) {
        startingPrice = document.createElement('div');
        startingPrice.className = 'gz-bike-starting-price';
        const common = prices.every(price => price === prices[0]);
        if (!common) startingPrice.appendChild(document.createTextNode('From '));
        const amount = document.createElement('span');
        amount.className = 'money';
        amount.textContent = format(Math.min(...prices));
        startingPrice.appendChild(amount);
        nativePrice.insertAdjacentElement('afterend', startingPrice);
      }
      colorSelect.insertAdjacentElement('afterend', group);
      oldHidden = colorSelect.hidden;
      colorSelect.hidden = true;
      colorSelect.setAttribute('data-gz-bike-native', '');
      ready = true;
      const linkedVariant = product.variants.find(variant => String(variant.id) === initialLinkedVariantId) || (root.dataset.forceSelection !== 'true' ? product.variants.find(variant => String(variant.id) === String(master.value)) : null);
      if (linkedVariant) {
        // Reapply a real deep link if another native initializer selected a default.
        const value = String(linkedVariant.options[0]);
        if (colorSelect.value !== value || String(master.value) !== String(linkedVariant.id)) {
          colorSelect.value = value;
          colorSelect.dispatchEvent(new Event('change', {bubbles: true}));
        }
      } else {
        let placeholder = Array.from(colorSelect.options).find(option => option.value === '');
        if (!placeholder) {
          placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Choose a Color';
          placeholder.disabled = true;
          colorSelect.insertBefore(placeholder, colorSelect.firstChild);
        }
        colorSelect.value = '';
        // One initialization only; never delayed resets after someone chooses a color.
        colorSelect.dispatchEvent(new Event('change', {bubbles: true}));
      }
      schedule();
    }
    const afterStep = event => {
      if (!(event.target instanceof Element) || !event.target.closest('.js-change-quantity')) return;
      clearTimeout(stepTimer);
      // Native Turbo updates quantity on body after form listeners. A microtask is too early.
      stepTimer = setTimeout(() => { stepTimer = null; normalize(); schedule(); }, 0);
    };
    const onVariant = event => {
      // Native fires this before its own inventory, max and availability updates finish.
      if (event.detail?.selector?.variantIdField === master) schedule();
    };
    const observer = new MutationObserver(schedule);
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'selected', 'hidden', 'max']});
    root.addEventListener('change', schedule);
    master.addEventListener('change', schedule);
    form.addEventListener('click', afterStep);
    document.addEventListener('variant:change', onVariant);
    if (jq) jq(input).on('input.gzBikeColors change.gzBikeColors', changed);
    else {
      input.addEventListener('input', changed);
      input.addEventListener('change', changed);
    }
    instances.set(root, {
      purchaseAllowed,
      focusMissing,
      destroy() {
        destroyed = true;
        clearTimeout(stepTimer);
        observer.disconnect();
        root.removeEventListener('change', schedule);
        master.removeEventListener('change', schedule);
        form.removeEventListener('click', afterStep);
        document.removeEventListener('variant:change', onVariant);
        if (jq) jq(input).off('.gzBikeColors');
        else {
          input.removeEventListener('input', changed);
          input.removeEventListener('change', changed);
        }
        if (colorSelect) {
          colorSelect.hidden = oldHidden;
          colorSelect.removeAttribute('data-gz-bike-native');
          if (originalSelectDisabled !== undefined) setDisabled(colorSelect, originalSelectDisabled);
        }
        paymentInert.forEach((inert, payment) => { payment.inert = inert; });
        setClass(details, 'gz-bike-price-incomplete', false);
        startingPrice?.remove();
        group?.remove();
        instances.delete(root);
      }
    });
    initialize();
  }
  function scan() { document.querySelectorAll(rootSelector).forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => { if (event.target.contains(root)) instance.destroy(); });
  });
})();
